import styled from '@emotion/styled'
import { at } from '../../styles/utils'
import { breakpoints } from '../../styles/vars'

export const OverlayImage = styled.img`
  position: relative;
  width: 100%;
  height: auto;
  ${at(breakpoints.laptop)} {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: auto;
  }
`
